<template>
	<div class="box">
    <transition name="left">
    <div class="home-left" v-show="show">
        <mainES></mainES>
        <div class="sqlit"></div>
        <load/>
        <div class="sqlit"></div>
        <perceived/>
    </div>
    </transition>
    <transition name="right">
    <div class="home-right" v-show="show">
        <environment/>
        <div class="sqlit"></div>
        <patrol ref="sqlitRef"/>
        <div class="sqlit"></div>
        <patrolS/>
    </div>
    </transition>
    </div>
</template>
	
<script>
// @ is an alias to /src
import mainES from "../components/left/mainES";
import load from "../components/left/load";
import perceived from "../components/left/perceived";
import environment from "../components/right/environment";
import patrol from "../components/right/patrol";
import patrolS from "../components/right/patrolS";
import {ref} from 'vue';
export default {
  name: "Home",
  components: {
      mainES,
      load,
      perceived,
      environment,
      patrol,
      patrolS
  },
    setup(){
      var show = ref(false);
      var sqlitRef = ref(null);
        const homeShow = (flage)=>{
           show.value = flage;
           if(flage){
           	setTimeout(()=>{
           		sqlitRef.value.drawLine();
           	},1000)
           }
        };
        window.homeShow = homeShow;
        
      return{
          show,
          sqlitRef
      }
    }
};
</script>
<style scoped lang="less">
    @import "./../assets/canshu";
    .box{
    	position: absolute;
    	top: 0;
    	left: 0;
    	width: 100vw;
    	height: 100vh;
    	overflow: hidden;
    	pointer-events: none;
    }
    .left-enter-active, .left-leave-active {
        transition: all 1s;
    }
    .left-enter-from, .left-leave-to {
        transform: translateX(-100%);
    }
    .right-enter-active, .right-leave-active {
        transition: all 1s;
    }
    .right-enter-from, .right-leave-to {
        transform: translateX(100%);
    }
  .home-left{
    position: absolute;
    left: 20px;
    top: 8.62vh;
      z-index: 999;
      pointer-events: all;
  }
  .home-right{
    position: absolute;
    height: 89.62vh;
    right: 20px;
    top: 8.62vh;
      z-index: 999;
      pointer-events: all;
  }
    .sqlit{
        margin-top: 10vh*@vh;
    }
</style>
